import { render } from "./InspectionPage.vue?vue&type=template&id=049648b0"
import script from "./InspectionPage.vue?vue&type=script&lang=js"
export * from "./InspectionPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__